<template>
    <div class="CampaignShowFull">
        <div class="m-b-xl b-rad-t-lg bg-body">
            <div class="sm:flex v-center">
                <div class="campaign-image-wrapper flex-1">
                    <CampaignImage :campaign="campaign" />
                </div>
                <div class="cursor-pointer brand-information flex-1 text-center">
                    <img
                        :src="campaign.brand.logo_url"
                        class="spark-profile-photo-lg mx-auto"
                        alt=""
                    />
                    <h4 class="m-t-md" v-text="campaign.brand.name"></h4>
                </div>
            </div>
        </div>

        <div class="px-5 mb-5">
            <div>
                <p class="font-bold">{{ campaign.name }}</p>

                <div
                    class="mt-2 description-html"
                    v-html="campaign.description.replace(/\n/g, '<br>')"
                ></div>
            </div>

            <div style="margin-top: 20px;">
                <div class="flex">
                    <div>
                        <img src="/img/interests-icon.png" alt="interests" style="width: 50px;" />
                    </div>
                    <p style="line-height: 45px;margin-left: 10px;font-weight: 600;">
                        Verdensmål
                    </p>
                </div>
                <div class="interests-wrapper">
                    <div
                        v-for="interest in campaign.interests"
                        class="interest-box"
                        style="
                                            display: block;
                                            width: calc(25% - 10px);
                                            float: left;
                                            margin: 10px;
                                            margin-left: 0;
                                    "
                    >
                        <img :src="'/img/interests/' + interest.id + '.png'" :alt="interest.name" />
                    </div>
                    <div style="clear: both;" />
                </div>
                <CampaignListTrophies
                    v-if="hasRequiredTrophiesFor(campaign)"
                    :required-trophies="requiredTrophiesFor(campaign)"
                />
                <!-- <div v-if="campaign.reach_required" class="flex justify-between mt-5">
                    <div style="flex-wrap: wrap;" class="flex mt-5">
                        <div>
                            <span
                                style="color: #1825d8;font-size: 30px;margin-right: 10px;"
                                :class="campaign.platform ? campaign.platform.icon : ''"
                            ></span>
                        </div>
                        <div style="font-size: 14px;line-height: 1.2;">
                            <p class="font-bold">Minimum amount of followers</p>
                            <p>
                                {{ campaign.reach_required }}
                            </p>
                        </div>
                    </div>
                </div> waitting build live -->
                <div v-if="campaign.reach_required" class="flex w-full mt-5">
                    <div class="flex">
                        <span
                            style="color: #1825d8;font-size: 30px;margin-right: 10px;"
                            :class="campaign.platform ? campaign.platform.icon : ''"
                        ></span>
                        <div style="font-size: 14px;line-height: 1.2;">
                            <p class="font-bold">
                                Foretrukket minimum antal
                                {{ campaign.platform.reach_name | lowercase }} på
                                {{
                                    campaign.platform.name === 'Instagram Business'
                                        ? 'instagram'
                                        : campaign.platform.name | lowercase
                                }}
                            </p>
                            <p>{{ campaign.reach_required }}</p>
                        </div>
                    </div>
                </div>
                <div class="flex justify-between mt-5">
                    <div class="flex flex-wrap">
                        <div>
                            <span class="mr-2.5 block">
                                <img src="/img/icons/clock.svg" alt="info" style="width: 25px;" />
                            </span>
                        </div>
                        <div style="font-size: 14px;line-height: 1.2;">
                            <p class="font-bold">Ansøgningsfrist</p>
                            <p>{{ new Date(campaign.expires_at).toLocaleDateString('da-DK') }}</p>
                        </div>
                    </div>

                    <!--
                    <button class="" style="background: #ff00a7;color: white;padding: 3px 12px;line-height: 1.6;">Se job</button>
                    -->
                </div>
            </div>
        </div>

        <div>
            <div class="text-center">
                <slot v-if="campaign.influencer_profit" name="apply-message">
                    <div>
                        <hr />

                        <div class="text-center lead m-lg">
                            <div class="tooltip-container">
                                <p
                                    class="text-base cursor-pointer font-medium flex items-center gap-2 justify-center"
                                >
                                    <span>Mængden af indhold i dette job</span>
                                    <img
                                        src="/img/icons/icon_tooltip_influencer.svg"
                                        alt="tooltip"
                                        width="20"
                                    />
                                </p>
                                <div class="tooltip-card tooltip-card-top">
                                    <p class="m-0 text-base">
                                        Dette er, hvad brandet kræver, at du skal poste for at få
                                        jobbet godkendt. Mængden af indhold er fastlagt og kan ikke
                                        forhandles. Sørg derfor for, at du forstår omfanget af
                                        opgaven, før du ansøger om jobbet.
                                    </p>
                                </div>
                            </div>
                            <span class="hidden">Betaling:</span>
                            <strong class="hidden"
                                ><amount :value="campaign.influencer_profit"></amount>*</strong
                            >
                            <p class="block my-1 text-base">
                                <span v-if="postType" v-for="postType in postTypes">
                                    <span v-if="postType.i > 1">|</span>
                                    {{ postType.name }}: {{ postType.amount }}
                                </span>
                            </p>
                            <div class="tooltip-container">
                                <p
                                    class="text-base cursor-pointer font-medium flex items-center gap-2 justify-center"
                                >
                                    <span>Ansøg om dette job</span>
                                    <img
                                        src="/img/icons/icon_tooltip_influencer.svg"
                                        alt="tooltip"
                                        width="20"
                                    />
                                </p>
                                <div class="tooltip-card tooltip-card-top">
                                    <p class="m-0 text-base">
                                        For at anmode om et job skal du angive dit honorar for
                                        opgavens udførelse. Brandet har derefter mulighed for at
                                        forhandle en endelig pris med dig. Jeres samarbejde starter
                                        først officielt, når begge parter er enige om en pris.
                                    </p>
                                    <p class="mt-1 text-base">
                                        Husk, at dit bud bør baseres på antallet af dine følgere
                                        samt jobbets omfang. Bemærk, at minimumsprisen for et job er
                                        500 DKK.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="text-center m-lg small hidden">
                            *Dette er betalingen betterhype anbefaler ud fra dine følgere på
                            {{ campaign.platform.name | lowercase }}, samt antallet posts ønsket af
                            virksomheden. Du har mulighed for at foreslå en anden betaling.
                        </div>

                        <hr />
                        <a
                            v-if="hasAllRequiredTrophies"
                            :href="applyLink"
                            class="btn btn-animate btn-xl btn-success mt-5"
                        >
                            Anmod om job <i class="fa fa-arrow-right"></i>
                        </a>
                        <div v-else class="alert alert-warning mt-5 mb-0 text-left">
                            Du mangler påkrævede trofæer for at kunne anmode om dette job. Fuldfør trofæerne ovenfor først.
                        </div>
                        <!-- <div
                            v-if="
                                user.channels.some(
                                    channel =>
                                        channel.platform.name === campaign.platform.name &&
                                        campaign.reach_required <= channel.reach
                                )
                            "
                        >
                            <a :href="applyLink" class="btn btn-animate btn-xl btn-success">
                                Anmod om job <i class="fa fa-arrow-right"></i>
                            </a>
                        </div> waitting build live -->
                    </div>
                </slot>
                <slot v-else name="cant-apply-message">
                    <div class="alert alert-warning">
                        Du kan ikke anmode om job for denne kampagne, fordi du endnu ikke har
                        tilknyttet en <b>{{ campaign.platform.name }}</b> konto.
                        <br />
                        Hvis du oplever problemer, så kan du se vores guide
                        <a
                            class="font-bold hover:underline text-blue-400"
                            href="https://betterhype.com/wp-content/uploads/2025/02/Guide-for-Influencers_instagram_DK.pdf"
                            target="_blank"
                            >her</a
                        >.
                        <div class="m-t-lg">
                            <a href="/settings#channels" class="btn btn-success">
                                Tilknyt nu <i class="fa fa-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                </slot>
            </div>
        </div>
    </div>
</template>
<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.CampaignShowFull {
    .CampaignImage {
        margin-top: 40px;
        border-radius: 0;
        padding-top: 80%;
    }
    .brand-information {
        position: relative;
        margin-top: -40px;
        padding-bottom: 15px;
    }
}
.tooltip-card {
    visibility: hidden;
    background-color: rgb(255, 0, 167);
    color: white;
    position: absolute;
    z-index: 1;
    transform: translateX(-50%);
    left: 50%;
    border-radius: 12px;
    opacity: 0;
    transition: opacity 0.3s;
    width: 480px;
    padding: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    text-align: left;
}
.tooltip-card-top {
    bottom: 150%;
    &:after {
        content: '';
        position: absolute;
        bottom: -20px;
        left: 50%;
        transform: translateX(-50%);
        border-width: 20px 14px 0;
        border-style: solid;
        border-color: rgb(255, 0, 167) transparent transparent;
    }
}
.tooltip-card-bottom {
    top: 150%;
    &:before {
        content: '';
        position: absolute;
        top: -20px;
        left: 50%;
        transform: translateX(-50%);
        border-width: 0 14px 20px;
        border-style: solid;
        border-color: transparent transparent rgb(255, 0, 167);
    }
}
.tooltip-container {
    position: relative;
}
.tooltip-container:hover .tooltip-card {
    visibility: visible;
    opacity: 1;
}

@screen sm {
    .CampaignShowFull .CampaignImage {
        @apply m-0 rounded-none rounded-tl-lg;

        padding-top: 80%;
    }

    .CampaignShowFull .brand-information {
        margin: 0;
    }
}
</style>
<script type="text/babel">
import CampaignImage from 'dashboard-js/components/campaigns/CampaignImage'
import CampaignListTrophies from 'dashboard-js/components/campaigns/CampaignListTrophies'
import RequiredTrophies from 'dashboard-js/mixins/RequiredTrophies'
export default {
    components: { CampaignImage, CampaignListTrophies },

    mixins: [RequiredTrophies],

    props: ['campaign', 'user'],

    computed: {
        applyLink() {
            return route('influencer.campaign.show', this.campaign.id).toString()
        },
        schoolUrl() {
            return route('influencer.school').toString()
        },
        postTypes() {
            let i = 0
            return Object.keys(this.campaign.wanted_posts_types).map(key => {
                    if (parseInt(this.campaign.wanted_posts_types[key]['value']) <= 0) {
                        return null
                    }

                    i++
                    return {
                        i,
                        key,
                        name: this.campaign.wanted_posts_types[key]['title'],
                        amount: this.campaign.wanted_posts_types[key]['value'],
                    }
                })
        },
        hasAllRequiredTrophies() {
            return this.hasAllRequiredTrophiesFor(this.campaign)
        },
    },

    methods: {
        postTypeTitle(postTypeKey) {
            return (
                {
                    stories: 'stories',
                    reels: 'reels',
                    blog_posts: 'blog posts',
                }[postTypeKey] ?? postTypeKey
            )
        },
    },
}
</script>
